// extracted by mini-css-extract-plugin
export var icon = "_a1-3";
export var subtitle = "_a1-2";
export var title = "_a1-1";
export var value = "_a1-0";